import { useState } from "react";
import OutlinedButton from "../../../../components/common/OutlinedButton";
import PrimaryButton from "../../../../components/common/PrimaryButton";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import ConfirmationModal from "../confirmationModal";
import { isNoOp } from "../../../../setup/util/isNoOp";
import { ReactComponent as SaveLater } from "../../../../assets/images/svg/saveLater.svg";

interface IMilestoneFormNavButtonProps {
  handleNext: () => void;
  handlePrev: (() => void) | undefined;
  handleSaveDraft: () => void;
  disabled: boolean;
}

const MilestoneFormNavButton = ({
  handleNext,
  handlePrev,
  handleSaveDraft,
  disabled,
}: IMilestoneFormNavButtonProps) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <div className={styles.container}>
      {!isNoOp(handleSaveDraft) && (
        <OutlinedButton
          onClick={() => setModalOpen(true)}
          style={{
            width: "220px",
            color: "#0D44AD",
            background: "#F3F6FC",
            border: "none",
          }}>
          {t("lbl_save_and_continue_later")}
        </OutlinedButton>
      )}
      <div className={styles.buttonGroup}>
        {handlePrev && (
          <OutlinedButton
            onClick={handlePrev}
            style={{
              width: "170px",
              color: "black",
              borderColor: "#E2E5EE",
            }}>
            <img
              src="/assets/images/svg/rightArrow.svg"
              alt="edit"
              style={{ width: "16px", height: "16px", marginLeft: "8px" }}
            />{" "}
            {t("lbl_prev")}
          </OutlinedButton>
        )}
        <PrimaryButton
          disabled={disabled}
          onClick={handleNext}
          style={{
            width: "170px",
            background: !disabled ? "black" : "#EEF0F5",
          }}>
          {t("lbl_next")}{" "}
          <img
            src="/assets/images/svg/leftArrow.svg"
            alt="edit"
            style={{ width: "16px", height: "16px", marginRight: "8px" }}
          />
        </PrimaryButton>
      </div>
      <ConfirmationModal
        handleClose={() => {
          setModalOpen(false);
        }}
        handleConfirm={async () => {
          await handleSaveDraft();
          setModalOpen(false);
        }}
        confirmText="حفظ كمسوده"
        cancelText="الرجوع"
        modalOpen={modalOpen}
        title={"حفظ البيانات والإكمال لاحقاً"}
        description={"سيتم حفظ المعامله كمسوده ويمكنك إكمال المعاملة لاحقًا"}
        icon={<SaveLater />}
        containerStyle={styles.modalContainer}
      />
    </div>
  );
};

export default MilestoneFormNavButton;
